export default __webpack_public_path__ + "static/media/clinic1.e518443f.jpg";